/* System defined core library */
import { Injectable } from '@angular/core';

/* User defined library/components */
import { BootstrapParams } from '../../../../bootstrap-params';
import { HttpService } from '../../../core/http.service';
import { SelectedExamDetailService } from './selected-exam-detail.service';

/* User defined models */
import { AppointmentDetail } from '../../../shared/models/scheduling/appointmentdetail.model';
import { Client } from '../../../shared/models/scheduling/client.model';
import { EligibilityDetail } from '../../../shared/models/scheduling/eligibility.model';
import { ExamSet } from '../../../shared/models/scheduling/examSet.model';
import { Hold } from '../../../shared/models/scheduling/hold.model';
import { MetricDetails, MetricRequest } from '../../../shared/models/scheduling/metrics.model';
import { Program } from '../../../shared/models/scheduling/program.model';

/* User defined enums/constants */
import { InputType, LogLevel, NavigationAction } from '../../../shared/enums/scheduling.enum';


@Injectable()
export class MetricApiService {

  /* User defined private/public variables  */
  public client: Client;
  public hold: Hold;
  public program: Program;
  public selectedAppts: AppointmentDetail[];
  public eligibilityDetails: EligibilityDetail[] = [];


  constructor(
    private bootstrapParams: BootstrapParams,
    private httpService: HttpService,
    private selectedExamDetailService: SelectedExamDetailService
  ) {
    selectedExamDetailService.hold.subscribe((hold) => {
      this.hold = hold;
    });

    selectedExamDetailService.client.subscribe((client) => {
      this.client = client;
    });

    selectedExamDetailService.program.subscribe((program) => {
      this.program = program;
    });

    selectedExamDetailService.eligibilityDetails.subscribe((eligibilityDetails) => {
      this.eligibilityDetails = eligibilityDetails;
    });

    selectedExamDetailService.selectedAppointmentDetails.subscribe((selectedAppointmentDetails) => {
      this.selectedAppts = selectedAppointmentDetails;
    });
  }

  public postMetricDetails(metricDetails: MetricDetails, bookingId?: string, status?: string) {
    this.setMetricDetail(MetricRequest.convertMetricDetailsToRequest(metricDetails, bookingId, status));
  }

  private setMetricDetail(metricRequest: MetricRequest) {
    if (!this.selectedExamDetailService.skipMetrics) {
      this.httpService.post(this.bootstrapParams.MetricRootApiUrl + 'api/v1/metrics', metricRequest)
        .subscribe((rNArray: any) => {
        });
    }
  }

  public log(level: LogLevel, body: string): void {
    const flow = !!this.selectedExamDetailService.currentTargetFlow ? this.selectedExamDetailService.currentTargetFlow : 'Home';
    let cpeMsg = '';

    if (this.client && this.client.code) {
      cpeMsg += `\nClient: ${this.client.code}`;
    }
    if (this.program && this.program.code) {
      cpeMsg += `\nProgram: ${this.program.code}`;
    }
    if (this.selectedAppts && this.selectedAppts.length) {
      cpeMsg += `\nExam ${this.selectedAppts[0].exam.code}`;
    }

    const content = {
      'Level': level,
      'Body': `Proscheduler UI: ${flow}: ` + body + cpeMsg
    };

    this.httpService.postWithoutLoader(this.bootstrapParams.MetricRootApiUrl + 'api/v1/logging', content)
      .subscribe((rNArray: any) => {
      });
  }

  public logNavigation(page: string, action: NavigationAction, input?: InputType) {
    let msg = `Candidate took a ${action} action on the ${page} page using `;
    msg += !!input ? 'the ' + input : 'an unknown method';
    if (!!this.hold && !!this.hold.id) { msg += `\nHold: ${this.hold.id}`; }
    if (!!this.selectedAppts && !!this.selectedAppts[0] && !!this.selectedAppts[0].ConfirmationNumber) { msg += `\nConfirmationNumber: ${this.selectedAppts[0].ConfirmationNumber}`; }
    this.log(LogLevel.Debug, msg);
  }

  public logExamSetModalityConflict(set: ExamSet) {
    let msg = `User presented with unschedulable examset in ${this.selectedExamDetailService.isProctored ? 'Proctor' : 'Non-Proctor'} flow`;
    msg = msg + `\nExamset: ${!!set && !!set.id ? set.id : 'N/A'}`;
    if (!!this.eligibilityDetails && !!this.eligibilityDetails.length && !!this.eligibilityDetails[0] && !!this.eligibilityDetails[0].number) {
      msg = msg + `\nElig: ${this.eligibilityDetails[0].number}`;
    }

    this.log(LogLevel.Warn, msg);
  }

  private isNullOrUndefined(object: any): boolean {
    if (object == null || object == undefined) {
      return true;
    }
    else { return false; }
  }
}
